<!-- eslint-disable -->
<template lang="pug">
    .pagination-box
        nav.pagination(v-if="lastPage && lastPage > 1")
            router-link.pagination-previous(
                v-if="isDataFromQuery"
                :disabled="currentPage === 1"
                :to="{query: {page: currentPage - 1}}"
            )
                svg-icon(name="angle-left" height="19px" width="12px")
            .pagination-previous(
                v-else
                @click="$emit('changePage', 'prev')"
            )
                svg-icon(name="angle-left" height="19px" width="12px")
            ul.pagination-list(v-if="lastPage > 1")
                li(v-for="pageNumber in pages")
                    template(v-if="pageNumber === '...'")
                        span(class="pagination-ellipsis") &hellip;
                    template(v-else)
                        router-link.pagination-link(
                            v-if="isDataFromQuery"
                            :to="{query: {page: pageNumber}}"
                            :class="{'pagination-link--current': pageNumber === currentPage}"
                        )
                            | {{ pageNumber }}
                        .pagination-link(
                            v-else
                            @click="$emit('changePage', pageNumber)"
                            :class="{'pagination-link--current': pageNumber === currentPage}"
                        )
                            | {{ pageNumber }}
            router-link.pagination-next(
                v-if="isDataFromQuery"
                :disabled="currentPage === lastPage"
                :to="{query: {page: currentPage + 1}}"
            )
                svg-icon(name="angle-right" height="19px" width="12px")
            .pagination-next(
                v-else
                @click="$emit('changePage', 'next')"
            )
                svg-icon(name="angle-right" height="19px" width="12px")
        .pagination-info(v-if="total")
            | {{ $i18n.tc('common.common_pagination_showing', length) }}
            | {{from}} - {{to}}
            | {{ $i18n.t('common.common_pagination_showingOf') }}
            | {{total}}
</template>

<script>
    /*eslint-disable*/

    import paginate from '../../utils/paginate';

    export default {
        props: {
            lastPage: {
                type: Number
            },
            currentPage: {
                type: Number
            },
            total: {
                type: Number
            },
            length: {
                type: Number
            },
            from: {
                type: Number
            },
            to: {
                type: Number
            },
            isDataFromQuery: {
                type: Boolean,
                default: true
            }
        },
        mixins: [paginate]
    }
</script>

<style lang="scss" scoped>
    .pagination-box {
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        flex-wrap: nowrap;
    }

    .pagination-list {
        margin-top: 0;
        display: flex;
        order: 0;
        @include media($md) {
            margin-top: .75rem;
        }
    }

    .pagination-link, .pagination-ellipsis {
        order: 0;
        opacity: 1;
        min-width: 0;
        background-color: $x-color-white;
        padding: 4px 10px;
        cursor: pointer;

        border: 1px solid $hsl-color-gray-74;
        box-sizing: border-box;
        border-radius: 5px;

        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: $x-color-full-black;
        @media screen and (min-width: 400px) {
            padding: 10px 16px;
        }
        @media screen and (min-width: 468px){
            margin: 0 5px;
        }
    }

    .pagination-link:hover {
        border: 1px solid $hsl-color-blue-56;
    }

    .pagination-link--current {
        border: 1px solid $hsl-color-blue-56;
        background-color: $hsl-color-blue-56;
        color: $x-color-white;
    }

    .pagination-previous,
    .pagination-next {
        // Reset bulma class
        padding: 0;
        order: 0;
        background: none;
        opacity: 1;
        border: medium none transparent;
        min-width: 0;
        //
        margin: 10px 5px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        cursor: pointer;
        @include media($md) {
            margin: 10px 5px 0;
        }
        &:hover {
            color: $hsl-color-blue-48;
        }
    }

    .pagination-info {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: $x-color-black;
    }

    .pagination-info:not(:first-child) {
        margin-top: 20px;
    }
</style>
